import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

import { Logo } from '@/assets/svg'
import { env } from '@/config/env'

// Same list as legacy routes.js: "Jobs" is an EXTERNAL link into the talent app (route exists
// there; anonymous visitors get its login redirect), "Employers" is internal. "Salaries" was
// already commented out in legacy and stays out.
const ROUTE_LIST = [
  { label: 'Jobs', path: '/jobs', href: `${env.talentAppUrl}/jobs` },
  { label: 'Employers', path: '/employers' },
] as const

export function Header() {
  return (
    <>
      <HeaderDesktop />
      <HeaderMobile />
    </>
  )
}

function HeaderDesktop() {
  return (
    <header className="site-header header-desktop">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <img src={Logo} alt="Bright.source" />
        </Link>

        <nav className="header-tabs">
          {ROUTE_LIST.map((route) =>
            'href' in route && route.href ? (
              <a key={route.path} href={route.href}>
                {route.label}
              </a>
            ) : (
              <NavLink key={route.path} to={route.path}>
                {route.label}
              </NavLink>
            ),
          )}
        </nav>

        <div className="header-actions">
          <a className="btn-primary" href={`${env.talentAppUrl}/login`}>
            Log in
          </a>
        </div>
      </div>
    </header>
  )
}

function HeaderMobile() {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => {
    // The slide-in menu covers the viewport; without this the page behind it still scrolls.
    document.body.style.overflow = isOpen ? 'visible' : 'hidden'
    setIsOpen((x) => !x)
  }

  const close = () => {
    document.body.style.overflow = 'visible'
    setIsOpen(false)
  }

  return (
    <header className="site-header header-mobile">
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={close}>
          <img src={Logo} alt="Bright.source" />
        </Link>

        <div className={`header-links${isOpen ? ' active' : ''}`}>
          {ROUTE_LIST.map((route) =>
            'href' in route && route.href ? (
              <a key={route.path} href={route.href}>
                {route.label}
              </a>
            ) : (
              <NavLink key={route.path} to={route.path} onClick={close}>
                {route.label}
              </NavLink>
            ),
          )}

          {/* Legacy's mobile menu linked "Log in" to the landing root — a dead end. Same label,
              real login page, matching the desktop header. */}
          <a href={`${env.talentAppUrl}/login`}>Log in</a>
        </div>

        <div className="header-actions">
          <div className={`hamburger${isOpen ? ' active' : ''}`} onClick={handleToggle}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>
    </header>
  )
}
